import React, { Suspense } from 'react';

/**
 * Wraps lazy routes in Suspense without blanking the screen.
 * Avoids opacity-0 fades and keyed remounts — those caused white flashes
 * between navigations on dark pages.
 */
export default function RouteTransition({ children }) {
  return <Suspense fallback={null}>{children}</Suspense>;
}
